import { render } from "./Header.vue?vue&type=template&id=61dd7a3d"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=61dd7a3d&lang=scss"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "61dd7a3d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61dd7a3d', script)) {
    api.reload('61dd7a3d', script)
  }
  
  module.hot.accept("./Header.vue?vue&type=template&id=61dd7a3d", () => {
    api.rerender('61dd7a3d', render)
  })

}

script.__file = "src/components/Header.vue"

export default script